import { AxiosPromise } from 'axios';

import { ISearch } from '~/components/Pagination/Search';
import { IPagination } from '~/models/Common';
import { IExercise, IExerciseRequiredForm, ISegments } from '~/models/Exercise';
import { exercisesMock } from '~/utils/mocks/exercisesMock';

import api from './api';

const ExerciseService = {
  getAllSegments(): AxiosPromise<ISegments[]> {
    return api.get('ex-editors/admin/all');
  },

  getAllExercises(
    segmentName: string,
    data: ISearch,
  ): AxiosPromise<ISegments[]> {
    return api.get('ex-editors/admin/all', {
      params: { ...data, muscle_segment: segmentName },
    });
  },

  getOneExercise(exerciseId: string): AxiosPromise<IExercise> {
    return api.get(`ex-editors/${exerciseId}`);
  },

  createExercise(data: IExerciseRequiredForm): AxiosPromise<IExercise> {
    return api.post('ex-editors', data);
  },

  editExercise(
    exerciseId: string,
    data: IExerciseRequiredForm,
  ): AxiosPromise<IExercise> {
    return api.put(`ex-editors/${exerciseId}`, data);
  },

  deleteExercise(exerciseId: string): AxiosPromise<IExercise> {
    return api.delete(`ex-editors/${exerciseId}`);
  },
};

export default ExerciseService;
